export * from './product-detail';
